import { render } from "./Installation.vue?vue&type=template&id=c9a56458&scoped=true&ts=true"
import script from "./Installation.vue?vue&type=script&lang=ts"
export * from "./Installation.vue?vue&type=script&lang=ts"

import "./Installation.vue?vue&type=style&index=0&id=c9a56458&scoped=true&lang=css"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9a56458"]])

export default __exports__